import { Component, OnInit, signal } from "@angular/core";
import { DataService } from "../../data.service";
import { TrackDataModel } from "../../model";
import { Confirmation, ConfirmationService } from "primeng/api";

interface EventItem {
    status?: string;
    date?: number;
    icon?: string;
    color?: string;
    image?: string;
}

@Component({
    selector: 'app-tracks-list',
    templateUrl: './tracks-list.component.html',
    styleUrls: ['./tracks-list.component.css'],
    standalone: false
})
export class TracksListComponent implements OnInit {
    private tracksData: TrackDataModel[] = [];
    statusOptions = [
        { name: "Все треки", value: 0, visible: true, color: '' },
        { name: "Добавлено", value: 1, visible: true, color: '#A3A2A2' },
        { name: "На складе", value: 2, visible: true, color: '#5A1F84' },
        { name: "Отправлено", value: 4, visible: true, color: '#EC9E18' },
        { name: "Прибыло", value: 5, visible: true, color: '#1F8472' },
        { name: "Вручено", value: 6, visible: true, color: '#2EA6EA' },
        { name: "Хранение", value: 7, visible: true, color: '#А97316' },
    ];
    currentStatusFilter = this.statusOptions[0];

    historyWndVisible: boolean = false;
    addTrackWndVisible: boolean = false;
    currentTrack?: TrackDataModel;
    trackHistoryEvents = signal<EventItem[]>([]);

    constructor(private dataService: DataService, private confirmationService: ConfirmationService) { }

    ngOnInit() {
        this.loadTracksData();
    }

    loadTracksData() {
        //this.currentTrack = undefined;

        let subsrc = this.dataService.userTracks().subscribe({
            next: (tracks: TrackDataModel[]) => {
                this.tracks = tracks;
            },
            error: (err) => {
                subsrc.unsubscribe();
                alert(`Error: ${err.message}`);
            },
            complete: () => {
                subsrc.unsubscribe();
            }
        });
    }

    /**
     * Set tracks data with sorting
     */
    set tracks(_tracksData: TrackDataModel[]) {
        const sortedByStatus = _tracksData.sort((a, b) => {
            if (a && b && a.status_id && b.status_id) {
                return Number(b.status_id) - Number(a.status_id)
            } else {
                return 0;
            }
        });

        const sortedByDate = sortedByStatus.sort((a, b) => {
            if (a && b && a.status_id && b.status_id && a.dt && b.dt) {
                if (a.status_id === b.status_id) {
                    return b.dt - a.dt;
                } else {
                    return 0;
                }
            } else {
                return 0;
            }
        });

        this.tracksData = sortedByDate;
    }

    /**
     * Get sorted tracks data
     */
    get tracks(): TrackDataModel[] {
        return this.tracksData;
    }

    onFilterChange(filterVal: any) {
        this.currentStatusFilter = filterVal.value;
    }

    getStatusColor(statusId: number): string {
        return this.statusOptions.find((status) => {
            return status.value === statusId
        })?.color ?? "red";
    }

    showAddTrackWnd() {
        this.addTrackWndVisible = true;
    }

    showHistoryWnd(track: TrackDataModel) {
        this.currentTrack = track;

        const subscr = this.dataService.trackHistory(track.id).subscribe({
            next: (data) => {
                const events: EventItem[] = [];

                data.forEach((item) => {
                    const event = {
                        status: item.status,
                        date: item.dt,
                        icon: 'pi pi-check',
                        color: item.status_id === 6 ? '#F1F8472' : '#FA3A2A2',
                    };
                    events.push(event);
                });

                this.trackHistoryEvents.set(events);
            },
            complete: () => {
                subscr.unsubscribe();
                this.historyWndVisible = true;
            },
            error: (err) => {
                subscr.unsubscribe();
                this.currentTrack = undefined;
                this.trackHistoryEvents.set([]);
            }
        });

    }

    deleteTrack(trackId: number) {
        // const confirmation: Confirmation = {};
        // confirmation.acc

        this.confirmationService.confirm({
            header: "Внимание!",
            message: 'Вы уверены, что хотите удалить данный трек-номер?',
            icon: 'pi pi-question-circle',
            acceptButtonStyleClass: 'p-button-danger p-button-sm',
            accept: () => {
                const subsrc = this.dataService.deleteCustomerTrack(trackId).subscribe({
                    next: (data) => {
                        this.loadTracksData();
                    },
                    complete: () => {
                        subsrc.unsubscribe();
                    },
                    error: (err) => {
                        subsrc.unsubscribe();
                    }
                });
            }
        });
    }

    clearCurrentTrack() {
        this.currentTrack = undefined;
    }
}